
(() => {
  if (window.meloraPdpV2Loaded) return;
  window.meloraPdpV2Loaded = true;

  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root = document) {
    root.querySelectorAll('[data-mlv2-carousel]').forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';

      const track = el.querySelector('[data-track]');
      const prev = el.querySelector('[data-prev]');
      const next = el.querySelector('[data-next]');
      const count = el.querySelector('[data-position]');
      if (!track || !prev || !next) return;

      const update = () => {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

        const cards = Array.from(track.children);
        const x = track.getBoundingClientRect().left;
        const index = Math.max(
          0,
          cards.findIndex(card => card.getBoundingClientRect().right > x + 20)
        );

        if (count) count.textContent = `${index + 1} / ${cards.length}`;
      };

      const move = sign => {
        const card = track.firstElementChild;
        if (card) {
          track.scrollBy({
            left: sign * (
              card.getBoundingClientRect().width +
              parseFloat(getComputedStyle(track).gap || 0)
            ),
            behavior: reduced() ? 'auto' : 'smooth'
          });
        }
      };

      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });

      const observer = new ResizeObserver(update);
      observer.observe(track);

      el.mlv2Cleanup = () => observer.disconnect();
      update();
    });

    root.querySelectorAll('[data-mlv2-product]').forEach(el => {
      if (el.dataset.mlv2Ready) return;
      el.dataset.mlv2Ready = 'true';

      // Preserve alternate-template variant URL handling.
      customElements.whenDefined('product-info').then(() => {
        const original = el.buildRequestUrlWithParams;
        if (typeof original !== 'function') return;

        const originalUpdateUrl = el.updateURL;

        if (typeof originalUpdateUrl === 'function') {
          el.updateURL = function(...args) {
            originalUpdateUrl.apply(this, args);

            if (
              this.dataset.updateUrl !== 'false' &&
              this.dataset.mlv2View
            ) {
              const previewUrl = new URL(location.href);
              previewUrl.searchParams.set(
                'view',
                this.dataset.mlv2View
              );

              history.replaceState(
                history.state,
                '',
                previewUrl.pathname +
                previewUrl.search +
                previewUrl.hash
              );

              this.querySelector('share-button')?.updateUrl(
                previewUrl.href
              );
            }
          };
        }

        el.buildRequestUrlWithParams = function(...args) {
          const url = new URL(
            original.apply(this, args),
            location.origin
          );

          if (el.dataset.mlv2View) {
            url.searchParams.set('view', el.dataset.mlv2View);
          }

          return url.pathname + url.search;
        };
      });

      // Gallery shortcut:
      // Show only on original first media.
      // Do not change video or thumbnail order.

      const mediaJumps = el.querySelector('.mlv2__media-jumps');
      const gallery = el.querySelector('media-gallery');
      const viewer = gallery?.querySelector(
        '[id^="GalleryViewer-"]'
      );

      if (mediaJumps && gallery && viewer) {
        // Position button inside the main media viewer.
        viewer.appendChild(mediaJumps);

        const mediaItems = () => Array.from(
          viewer.querySelectorAll(
            '.product__media-item[data-media-id]'
          )
        );

        const firstMediaId = mediaItems()[0]?.dataset.mediaId;

        const updateShortcutVisibility = () => {
          const items = mediaItems();

          const active = items.find(item =>
            item.classList.contains('is-active')
          );

          const show = Boolean(
            firstMediaId &&
            active?.dataset.mediaId === firstMediaId
          );

          mediaJumps.classList.toggle('is-visible', show);
        };

        // Detect main gallery media changes.
        const mediaList =
          viewer.querySelector('.product__media-list') || viewer;

        const observer = new MutationObserver(
          updateShortcutVisibility
        );

        observer.observe(mediaList, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'aria-hidden']
        });

        // Activate the selected video without reordering it.
        mediaJumps
          .querySelectorAll('[data-media-jump]')
          .forEach(button => {
            button.addEventListener('click', () => {
              const id = button.dataset.mediaJump;

              if (
                typeof gallery.setActiveMedia !== 'function'
              ) return;

              // false prevents Dawn from prepending
              // the video to the front of the gallery.
              gallery.setActiveMedia(id, false);

              const thumbnailButton = Array.from(
                gallery.querySelectorAll('[data-target]')
              ).find(item => item.dataset.target === id);

              const thumbnailItem =
                thumbnailButton?.closest(
                  '.thumbnail-list__item'
                ) || thumbnailButton;

              // Scroll the thumbnail strip to the video.
              thumbnailItem?.scrollIntoView({
                behavior: reduced() ? 'auto' : 'smooth',
                block: 'nearest',
                inline: 'nearest'
              });

              updateShortcutVisibility();
            });
          });

        updateShortcutVisibility();

        el.mlv2GalleryCleanup = () => {
          observer.disconnect();
        };
      }
    });
  }

  // Existing scrolling-strip pause functionality.
  document.addEventListener('click', event => {
    const button = event.target.closest(
      '[data-mlv2-pause]'
    );

    if (!button) return;

    const strip = button.closest('.mlv2__strip');
    if (!strip) return;

    const paused = strip.dataset.paused !== 'true';

    strip.dataset.paused = String(paused);
    button.setAttribute('aria-pressed', String(paused));

    button.textContent = paused
      ? button.dataset.playLabel
      : button.dataset.pauseLabel;
  });

  // Shopify theme editor events.
  document.addEventListener(
    'shopify:section:load',
    e => init(e.target)
  );

  document.addEventListener(
    'shopify:section:unload',
    e => {
      e.target
        .querySelectorAll('[data-mlv2-carousel]')
        .forEach(el => el.mlv2Cleanup?.());

      e.target
        .querySelectorAll('[data-mlv2-product]')
        .forEach(el => el.mlv2GalleryCleanup?.());
    }
  );

  document.addEventListener(
    'shopify:block:select',
    e => {
      const card = e.target.closest('.mlv2__review');

      if (card) {
        card.scrollIntoView({
          behavior: 'auto',
          block: 'nearest',
          inline: 'start'
        });
      }

      const details = e.target.closest('details');
      if (details) details.open = true;
    }
  );

  // Preserve stock message syncing with variants.
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(
      PUB_SUB_EVENTS.optionValueSelectionChange,
      ({ data }) => {
        const productInfo = data?.event?.target?.closest(
          'product-info[data-mlv2-product]'
        );

        productInfo
          ?.querySelector('[data-melora-scarcity]')
          ?.classList.add('hidden');
      }
    );

    subscribe(
      PUB_SUB_EVENTS.variantChange,
      ({ data }) => {
        if (!data) return;

        const productInfo = document.querySelector(
          `product-info[data-mlv2-product][data-section="${data.sectionId}"]`
        );

        if (!productInfo) return;

        const scarcity = productInfo.querySelector(
          '[data-melora-scarcity]'
        );

        if (!scarcity) return;

        const updatedScarcity = data.html?.querySelector(
          '[data-melora-scarcity]'
        );

        const updatedText = updatedScarcity?.querySelector(
          '.melora-scarcity__text'
        );

        const currentText = scarcity.querySelector(
          '.melora-scarcity__text'
        );

        if (updatedText && currentText) {
          currentText.textContent =
            updatedText.textContent.trim();
        }

        const shouldShow =
          data.variant?.available === true &&
          Boolean(updatedScarcity) &&
          !updatedScarcity.classList.contains('hidden');

        scarcity.classList.toggle(
          'hidden',
          !shouldShow
        );
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init()
    );
  } else {
    init();
  }
})();
